import _ from 'lodash';
import KeywordObject from './SpottingGroupKeywordObject';

class SpottingGroup {
  constructor({ groupName, keywords = [] }) {
    this.groupName = groupName;
    this.keywords = keywords;
  }

  get keywords() {
    return this._keywords;
  }

  set keywords(value) {
    this._keywords = SpottingGroup.keywordsFromTerms(value);
  }

  toJSON() {
    return {
      groupName: this.groupName,
      keywords: this.keywords,
    };
  }

  toCSV() {
    return this.keywords.map(term => `"${term}"`).join('\n');
  }
}

SpottingGroup.keywordsFromTerms = (value) => {
  let keywords = value;
  if (!Array.isArray(keywords)) {
    if (typeof value === 'string') {
      keywords = keywords.split(/[\n\r]+/g);
    } else {
      keywords = [];
    }
  }

  const out = _(keywords)
    .reject((term) => {
      if (term instanceof KeywordObject) {
        return term.isError || term.empty;
      }
      return false;
    })
    .map((keyword) => {
      if (keyword instanceof KeywordObject || (_.get(keyword, 'keyword'))) {
        return keyword.keyword;
      }
      return keyword;
    })
    .filter(s => (typeof s === 'string'))
    .map(s => s.split(',')[0])
    .compact()
    .sortBy()
    .uniq()
    .value();

  return out;
};

export default SpottingGroup;
